export default __webpack_public_path__ + "static/media/Product-screenshot.fd24f89b.png";